// src/panels/LabelPanel.jsx

import React, { useState, useEffect } from 'react';
import labelLibrary from '../libraries/LabelLibrary';
import ProjectManager from '../canvas/ProjectManager';

// ⬇️ NEW: pull uploaded labels + layer info
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import SearchIcon from '@mui/icons-material/Search';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import { Tooltip } from '@mui/material';

const LabelPanel = () => {
  const getActiveCell = () => ProjectManager.getSelectedCell?.();

  // ⬇️ Helper: merge created + uploaded GDS labels for active cell
const buildPanelLabels = () => {
    const cell = getActiveCell();
    if (!cell) return [];
    return labelLibrary.getAllLabels(cell) || [];
  };

  // state now built from merged list
  const [labels, setLabels] = useState(buildPanelLabels());
  const [isEditing, setIsEditing] = useState(false);
  const [editingLabelId, setEditingLabelId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [allVisible, setAllVisible] = useState(true);
  const [allLocked, setAllLocked] = useState(false);

  // at component top:
const [fontSize, setFontSize] = useState(12);

// helper to get active cell name (ProjectManager.getSelectedCell may return object or name)
const getActiveCellName = () => {
  const c = getActiveCell();
  // if ProjectManager returns a name string use it, otherwise return .name
  return c ? (typeof c === 'string' ? c : c.name || c.cellName || null) : null;
};


  const forceRefresh = () => setLabels(buildPanelLabels());

  // periodic refresh (skip during inline edit)
  // useEffect(() => {
  //   if (isEditing) return;
  //   const interval = setInterval(() => setLabels(buildPanelLabels()), 500);
  //   return () => clearInterval(interval);
  // }, [isEditing]);
  useEffect(() => {
  if (isEditing) return;

  // short poll for labels + active cell change
  const id = setInterval(() => {
    const lbls = buildPanelLabels();
    setLabels(lbls);

    const cellName = getActiveCellName();
    if (cellName) {
      const fs = labelLibrary.getCellFontSize(cellName);
      setFontSize(fs);
    } else {
      setFontSize(12);
    }
  }, 500);

  return () => clearInterval(id);
}, [isEditing]); // keep same dependency as before


  const handleEditStart = (labelId) => { setEditingLabelId(labelId); setIsEditing(true); };
  const handleEditChange = (e, labelId) => {
    const updatedText = e.target.value;
    setLabels(prev => prev.map(l => l.id === labelId ? { ...l, text: updatedText } : l));
  };
  const handleEditSave = (labelId) => {
    const found = labels.find(l => l.id === labelId);
    if (found && found.source !== 'uploaded') {
      labelLibrary.updateLabelText(labelId, found.text);
    }
    setEditingLabelId(null);
    setIsEditing(false);
  };

  // created-only actions remain same, but guard uploaded
  const handleDelete = (labelId) => {
    const label = labels.find(l => l.id === labelId);
    if (label && label.source !== 'uploaded') {
      labelLibrary.deleteLabel(getActiveCell(), label.layerId, label.id);
      forceRefresh();
    }
  };
  const toggleVisibility = (labelId) => {
    const label = labels.find(l => l.id === labelId);
    if (label?.source === 'uploaded') return; // read-only
    labelLibrary.toggleLabelVisibility(labelId);
    forceRefresh();
  };
  const toggleLock = (labelId) => {
    const label = labels.find(l => l.id === labelId);
    if (label?.source === 'uploaded') return; // read-only
    labelLibrary.toggleLabelLock(labelId);
    forceRefresh();
  };
  const toggleAllVisibility = () => {
    labelLibrary.toggleAllVisibility(!allVisible);
    setAllVisible(!allVisible);
    forceRefresh();
  };
  const toggleAllLock = () => {
    labelLibrary.toggleAllLock(!allLocked);
    setAllLocked(!allLocked);
    forceRefresh();
  };
  const handleDeleteAll = () => {
    labelLibrary.deleteAllLabels();
    forceRefresh();
  };

  const filteredLabels = labels.filter(l =>
    (l.text || '').toLowerCase().includes(searchTerm.toLowerCase())
  );

return (
  <div
    style={{
      padding: '12px',
      overflowY: 'auto',
      maxHeight: '100%',
      background: '#1c1c1c',
      color: '#fff'
    }}
  >

    {/* Search */}
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        marginBottom: '8px',
        background: '#2a2a2a',
        borderRadius: '4px',
        padding: '4px 8px'
      }}
    >
      <SearchIcon style={{ marginRight: '6px', fontSize: '20px', color: '#aaa' }} />
      <input
        type="text"
        placeholder="Search label…"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{
          flexGrow: 1,
          background: 'transparent',
          border: 'none',
          outline: 'none',
          color: '#fff',
          fontSize: '14px'
        }}
      />
    </div>

    {/* bulk actions */}
    {/* <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '12px'
      }}
    >
      <Tooltip title="Hide All Labels" placement="top" arrow>
      <VisibilityIcon
        onClick={toggleAllVisibility}
        style={{ cursor: 'pointer', fontSize: '20px', color: '#ccc' }}
      />
      </Tooltip>
      <Tooltip title="Lock All Labels" placement="top" arrow>
      <LockIcon
        onClick={toggleAllLock}
        style={{ cursor: 'pointer', fontSize: '20px', color: '#ccc' }}
      />
      </Tooltip>
      <Tooltip title="Delete All Labels" placement="top" arrow>
      <DeleteSweepIcon
        onClick={handleDeleteAll}
        style={{ cursor: 'pointer', fontSize: '20px', color: '#ccc' }}
      />
      </Tooltip>
      
    </div> */}
    <div
  style={{
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '12px'
  }}
>
  {/* Toggle All Visibility */}
  <Tooltip
    title={allVisible ? "Hide All Labels" : "Show All Labels"}
    placement="top"
    arrow
  >
    <span>
      {allVisible ? (
        <VisibilityIcon
          onClick={() => {
            toggleAllVisibility();
            setAllVisible(false);
          }}
          style={{ cursor: 'pointer', fontSize: '20px', color: '#ccc' }}
        />
      ) : (
        <VisibilityOffIcon
          onClick={() => {
            toggleAllVisibility();
            setAllVisible(true);
          }}
          style={{ cursor: 'pointer', fontSize: '20px', color: '#ccc' }}
        />
      )}
    </span>
  </Tooltip>

  {/* Toggle All Lock */}
  <Tooltip
    title={allLocked ? "lock All Labels" : "Unlock All Labels"}
    placement="top"
    arrow
  >
    <span>
      {allLocked ? (
        <LockOpenIcon
          onClick={() => {
            toggleAllLock();
            setAllLocked(false);
          }}
          style={{ cursor: 'pointer', fontSize: '20px', color: '#ccc' }}
        />
      ) : (
        <LockIcon
          onClick={() => {
            toggleAllLock();
            setAllLocked(true);
          }}
          style={{ cursor: 'pointer', fontSize: '20px', color: '#ccc' }}
        />
      )}
    </span>
  </Tooltip>

  {/* Delete All Labels */}
  <Tooltip
    title="Delete All Labels"
    placement="top"
    arrow
  >
    <span>
      <DeleteSweepIcon
        onClick={handleDeleteAll}
        style={{ cursor: 'pointer', fontSize: '20px', color: '#ccc' }}
      />
    </span>
  </Tooltip>
</div>


    {/* Font Size Slider */}
      <Tooltip title="Increase Font Size" placement="top" arrow>
<div style={{ marginBottom: '12px' }}>
  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
    <label style={{ fontSize: '13px', color: '#ccc' }}>
      Font Size
    </label>

    <span style={{ fontSize: '13px', color: '#ccc' }}>
      {fontSize}px
    </span>
  </div>

  <input
    type="range"
    min="12"
    max="1000"
    value={fontSize}
    onChange={(e) => {
      const size = Number(e.target.value);
      setFontSize(size);

      const cellName = getActiveCellName();
      if (cellName) {
        labelLibrary.setFontSizeForCell(cellName, size); // per-cell setter
      } else {
        // optional fallback: global if no cell selected
        labelLibrary.setAllFontSize(size);
      }

      forceRefresh();
      window.canvasEngine?.draw?.();
    }}
    style={{ width: '100%', marginTop: '6px' }}
  />
</div>
</Tooltip>




    {filteredLabels.length === 0 && (
      <p style={{ color: '#888', fontSize: '13px' }}>No labels found</p>
    )}

    {/* {filteredLabels.map((label) => {
      return (
        <div
          key={label.id}
          style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: '8px',
            background: '#2a2a2a',
            borderRadius: '4px',
            padding: '6px 8px'
          }}
          onClick={() => window.canvasEngine?.focusOnLabel?.(label.id)}
          onMouseEnter={(e) => {
            e.currentTarget.querySelectorAll('svg').forEach((i) => (i.style.fontSize = '16px'));
            e.currentTarget.style.background = '#333';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.querySelectorAll('svg').forEach((i) => (i.style.fontSize = '18px'));
            e.currentTarget.style.background = '#2a2a2a';
          }}
        >
          {editingLabelId === label.id ? (
            <input
              type="text"
              value={label.text}
              onChange={(e) => handleEditChange(e, label.id)}
              onKeyDown={(e) => e.key === 'Enter' && handleEditSave(label.id)}
              onBlur={() => handleEditSave(label.id)}
              autoFocus
              style={{
                flexGrow: 1,
                background: '#444',
                border: 'none',
                outline: 'none',
                color: '#fff',
                fontSize: '13px',
                padding: '2px 4px',
                borderRadius: '4px'
              }}
            />
          ) : (
            <span
              style={{
                flexGrow: 1,
                fontSize: '13px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}
            >
              {label.text}
            </span>
          )}

          <EditIcon
            onClick={() => !label.locked && handleEditStart(label.id)}
            style={{
              cursor: label.locked ? 'not-allowed' : 'pointer',
              marginRight: '6px',
              fontSize: '18px',
              opacity: label.locked ? 0.5 : 1
            }}
            titleAccess={label.locked ? 'Locked — unlock to edit' : 'Edit'}
          />
          <DeleteIcon
            onClick={() => handleDelete(label.id)}
            style={{ cursor: 'pointer', marginRight: '6px', fontSize: '18px' }}
            titleAccess="Delete"
          />
          {label.visible !== false ? (
            <VisibilityIcon
              onClick={() => toggleVisibility(label.id)}
              style={{ cursor: 'pointer', marginRight: '6px', fontSize: '18px' }}
              titleAccess="Hide"
            />
          ) : (
            <VisibilityOffIcon
              onClick={() => toggleVisibility(label.id)}
              style={{ cursor: 'pointer', marginRight: '6px', fontSize: '18px' }}
              titleAccess="Show"
            />
          )}
          {label.locked ? (
            <LockIcon
              onClick={() => toggleLock(label.id)}
              style={{ cursor: 'pointer', fontSize: '18px' }}
              titleAccess="Unlock"
            />
          ) : (
            <LockOpenIcon
              onClick={() => toggleLock(label.id)}
              style={{ cursor: 'pointer', fontSize: '18px' }}
              titleAccess="Lock"
            />
          )}
        </div>
      );
    })} */}
    {filteredLabels.map((label) => {
  return (
    <div
      key={label.id}
      style={{
        display: 'flex',
        alignItems: 'center',
        marginBottom: '8px',
        background: '#2a2a2a',
        borderRadius: '4px',
        padding: '6px 8px'
      }}
      onClick={() => window.canvasEngine?.focusOnLabel?.(label.id)}
      onMouseEnter={(e) => {
        e.currentTarget
          .querySelectorAll('svg')
          .forEach((i) => (i.style.fontSize = '16px'));
        e.currentTarget.style.background = '#333';
      }}
      onMouseLeave={(e) => {
        e.currentTarget
          .querySelectorAll('svg')
          .forEach((i) => (i.style.fontSize = '18px'));
        e.currentTarget.style.background = '#2a2a2a';
      }}
    >
      {/* LEFT: text / inline edit */}
      {editingLabelId === label.id ? (
        <input
          type="text"
          value={label.text}
          onChange={(e) => handleEditChange(e, label.id)}
          onKeyDown={(e) => e.key === 'Enter' && handleEditSave(label.id)}
          onBlur={() => handleEditSave(label.id)}
          autoFocus
          style={{
            flexGrow: 1,
            background: '#444',
            border: 'none',
            outline: 'none',
            color: '#fff',
            fontSize: '13px',
            padding: '2px 4px',
            borderRadius: '4px'
          }}
        />
      ) : (
        <span
          style={{
            flexGrow: 1,
            fontSize: '13px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}
        >
          {label.text}
        </span>
      )}

      {/* RIGHT: ACTION ICONS */}

      {/* Edit */}
      <Tooltip
        title={label.locked ? 'Locked — unlock to edit' : 'Edit label'}
        placement="top"
      >
        <span>
          <EditIcon
            onClick={(e) => {
              e.stopPropagation();
              !label.locked && handleEditStart(label.id);
            }}
            style={{
              cursor: label.locked ? 'not-allowed' : 'pointer',
              marginRight: '6px',
              fontSize: '18px',
              opacity: label.locked ? 0.5 : 1
            }}
          />
        </span>
      </Tooltip>

      {/* Delete */}
      <Tooltip title="Delete label" placement="top">
        <span>
          <DeleteIcon
            onClick={(e) => {
              e.stopPropagation();
              handleDelete(label.id);
            }}
            style={{
              cursor: 'pointer',
              marginRight: '6px',
              fontSize: '18px'
            }}
          />
        </span>
      </Tooltip>

      {/* Visibility */}
      <Tooltip
        title={label.visible !== false ? 'Hide label' : 'Show label'}
        placement="top"
      >
        <span>
          {label.visible !== false ? (
            <VisibilityIcon
              onClick={(e) => {
                e.stopPropagation();
                toggleVisibility(label.id);
              }}
              style={{
                cursor: 'pointer',
                marginRight: '6px',
                fontSize: '18px'
              }}
            />
          ) : (
            <VisibilityOffIcon
              onClick={(e) => {
                e.stopPropagation();
                toggleVisibility(label.id);
              }}
              style={{
                cursor: 'pointer',
                marginRight: '6px',
                fontSize: '18px'
              }}
            />
          )}
        </span>
      </Tooltip>

      {/* Lock / Unlock */}
      <Tooltip
        title={label.locked ? 'Unlock label' : 'Lock label'}
        placement="top"
      >
        <span>
          {label.locked ? (
            <LockIcon
              onClick={(e) => {
                e.stopPropagation();
                toggleLock(label.id);
              }}
              style={{ cursor: 'pointer', fontSize: '18px' }}
            />
          ) : (
            <LockOpenIcon
              onClick={(e) => {
                e.stopPropagation();
                toggleLock(label.id);
              }}
              style={{ cursor: 'pointer', fontSize: '18px' }}
            />
          )}
        </span>
      </Tooltip>
    </div>
  );
})}

  </div>
);

};

export default LabelPanel;
